import { get, isUndefined } from 'lodash';

import { convertYearsMonthsToYears, convertYearsToYearsMonths } from '@funnels/utils';

import { useFormValues } from '../useFormValues';

export function useYearsMonthsToTermDecorator(
  termPath: string
): [number | undefined, number | undefined, (value?: number) => void, (value?: string) => void] {
  const [currentValues, setValue] = useFormValues();
  const term = get(currentValues, termPath);
  const { years, months } = !isUndefined(term)
    ? convertYearsToYearsMonths(term)
    : { years: undefined, months: undefined };

  function handleYearsChange(value?: number) {
    const y = !isUndefined(value) ? value : 0;
    const m = !isUndefined(months) ? months : 0;
    const converted = convertYearsMonthsToYears(y, m);

    setValue(termPath, converted);
  }

  function handleMonthsChange(value?: any) {
    const y = !isUndefined(years) ? years : 0;
    const m = !isUndefined(value) ? parseInt(value, 10) : 0;
    const converted = convertYearsMonthsToYears(y, m);

    setValue(termPath, converted);
  }

  return [years, months, handleYearsChange, handleMonthsChange];
}
